const T3Constants = {
    HtmlEntities: {
        MDASH: String.fromCharCode(8212) /* &mdash; */,
        NBSP: String.fromCharCode(160) /* &nbsp; */,
        NDASH: String.fromCharCode(8211) /* &ndash; */
    },
    KeyCodes: {
        BACKSPACE: 8,
        CTRL: 17,
        CTRL2: 91,
        ENTER: 13,
        ESCAPE: 27,
        Z: 90
    }
}

export default T3Constants
